module.exports = __webpack_public_path__ + "static/media/DocumentGridEmpty.a6d75da2.png";